var _rect, _path, _mask, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 28,
    height: 24,
    rx: 3,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 11C10 6.02944 14.0294 2 19 2H21C25.9706 2 30 6.02944 30 11V14H10V11Z",
    stroke: "white",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_956_1776",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 27.0004C24.2144 26.0882 25 24.6358 25 23C25 20.2386 22.7614 18 20 18C17.2386 18 15 20.2386 15 23C15 24.6358 15.7856 26.0882 17 27.0004V31C17 32.6569 18.3431 34 20 34C21.6569 34 23 32.6569 23 31V27.0004Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27.0004L21.7988 25.4012L21 26.0013V27.0004H23ZM17 27.0004H19V26.0013L18.2012 25.4012L17 27.0004ZM24.2012 28.5995C25.8969 27.3258 27 25.2914 27 23H23C23 23.9802 22.532 24.8505 21.7988 25.4012L24.2012 28.5995ZM27 23C27 19.134 23.866 16 20 16V20C21.6569 20 23 21.3431 23 23H27ZM20 16C16.134 16 13 19.134 13 23H17C17 21.3431 18.3431 20 20 20V16ZM13 23C13 25.2914 14.1031 27.3258 15.7988 28.5995L18.2012 25.4012C17.468 24.8505 17 23.9802 17 23H13ZM19 31V27.0004H15V31H19ZM20 32C19.4477 32 19 31.5523 19 31H15C15 33.7614 17.2386 36 20 36V32ZM21 31C21 31.5523 20.5523 32 20 32V36C22.7614 36 25 33.7614 25 31H21ZM21 27.0004V31H25V27.0004H21Z",
    fill: "white",
    mask: "url(#path-3-inside-1_956_1776)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/Locked.469968abc5b10033ba018cd60f9237c1.svg";
export { ForwardRef as ReactComponent };